export default __webpack_public_path__ + "exposed-text-section.png";